/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonCompanyDuration
 */
export interface JsonCompanyDuration {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonCompanyDuration
     */
    allowedActions?: Array<JsonCompanyDurationAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonCompanyDuration
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDuration
     */
    companyDurationId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDuration
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonCompanyDuration
     */
    durationId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyDuration
     */
    status?: JsonCompanyDurationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonCompanyDuration
     */
    title?: string;
}

/**
* @export
* @enum {string}
*/
export enum JsonCompanyDurationAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonCompanyDurationStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonCompanyDurationFromJSON(json: any): JsonCompanyDuration {
    return JsonCompanyDurationFromJSONTyped(json, false);
}

export function JsonCompanyDurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonCompanyDuration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'companyDurationId': !exists(json, 'companyDurationId') ? undefined : json['companyDurationId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'durationId': !exists(json, 'durationId') ? undefined : json['durationId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function JsonCompanyDurationToJSON(value?: JsonCompanyDuration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'companyDurationId': value.companyDurationId,
        'companyId': value.companyId,
        'durationId': value.durationId,
        'status': value.status,
        'title': value.title,
    };
}

